<template>
	<div class="addEdit-block" :style='{"padding":"30px","fontSize":"16px","color":"#666","background":"none"}'>
		<el-form
			:style='{"border":"1px solid #eee","padding":"30px","boxShadow":"0 0px 0px rgba(64, 158, 255, .3)","fontSize":"inherit","borderRadius":"6px","background":"#fff"}'
			class="add-update-preview"
			ref="ruleForm"
			:model="ruleForm"
			:rules="rules"
			label-width="150px"
		>
			<template>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="工号" prop="gonghao">
					<el-select 
						v-model="ruleForm.gonghao" 
						placeholder="请选择或输入工号" 
						filterable 
						allow-create
						clearable
						@change="onGonghaoChange"
						:disabled="ro.gonghao">
						<el-option
							v-for="item in yuangongList"
							:key="item.gonghao"
							:label="item.gonghao"
							:value="item.gonghao">
							<span style="float: left">{{ item.gonghao }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.xingming }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="工号" prop="gonghao">
					<el-input v-model="ruleForm.gonghao" placeholder="工号" readonly></el-input>
				</el-form-item>

				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="select" v-if="type!='info'" label="姓名" prop="xingming">
					<el-select 
						v-model="ruleForm.xingming" 
						placeholder="请选择或输入姓名" 
						filterable 
						allow-create
						clearable
						@change="onXingmingChange"
						:disabled="ro.xingming">
						<el-option
							v-for="item in yuangongList"
							:key="item.xingming"
							:label="item.xingming"
							:value="item.xingming">
							<span style="float: left">{{ item.xingming }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.gonghao }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="姓名" prop="xingming">
					<el-input v-model="ruleForm.xingming" placeholder="姓名" readonly></el-input>
				</el-form-item>

				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'" label="部门" prop="bumen">
					<el-input v-model="ruleForm.bumen" placeholder="部门" clearable :readonly="ro.bumen"></el-input>
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="部门" prop="bumen">
					<el-input v-model="ruleForm.bumen" placeholder="部门" readonly></el-input>
				</el-form-item>

				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-if="type!='info'" label="项目名称" prop="xiangmumingcheng">
					<el-input v-model="ruleForm.xiangmumingcheng" placeholder="项目名称" clearable :readonly="ro.xiangmumingcheng"></el-input>
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else class="input" label="项目名称" prop="xiangmumingcheng">
					<el-input v-model="ruleForm.xiangmumingcheng" placeholder="项目名称" readonly></el-input>
				</el-form-item>

				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="textarea" v-if="type!='info'" label="项目详情" prop="xiangmuxiangqing">
					<el-input
						style="min-width: 200px; max-width: 600px;"
						type="textarea"
						:rows="8"
						placeholder="项目详情"
						v-model="ruleForm.xiangmuxiangqing"
						:readonly="ro.xiangmuxiangqing">
					</el-input>
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' v-else-if="ruleForm.xiangmuxiangqing" label="项目详情" prop="xiangmuxiangqing">
					<span :style='{"fontSize":"inherit","lineHeight":"40px","color":"inherit","fontWeight":"500","display":"inline-block"}'>{{ruleForm.xiangmuxiangqing}}</span>
				</el-form-item>

				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="date" v-if="type!='info'" label="记录时间" prop="jilushijian">
					<el-date-picker
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						v-model="ruleForm.jilushijian" 
						type="datetime"
						:readonly="ro.jilushijian"
						placeholder="记录时间"
					></el-date-picker> 
				</el-form-item>
				<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' class="input" v-else-if="ruleForm.jilushijian" label="记录时间" prop="jilushijian">
					<el-input v-model="ruleForm.jilushijian" placeholder="记录时间" readonly></el-input>
				</el-form-item>
			</template>

			<el-form-item :style='{"width":"100%","padding":"0","margin":"0","fontSize":"inherit","textAlign":"center"}' class="btn">
				<el-button class="btn3" v-if="type!='info'" type="success" @click="onSubmit">
					<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
					保存
				</el-button>
				<el-button class="btn4" v-if="type!='info'" type="success" @click="back()">
					<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					取消
				</el-button>
				<el-button class="btn5" v-if="type=='info'" type="success" @click="back()">
					<span class="icon iconfont icon-fanhui" :style='{"margin":"0 2px","fontSize":"inherit","color":"rgba(86,178,198,1)","height":"40px"}'></span>
					返回
				</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: '',
			type: '',
			yuangongList: [], // 员工列表数据
			ruleForm: {
				gonghao: '',
				xingming: '',
				bumen: '',
				touxiang: '',
				xiangmumingcheng: '',
				xiangmuxiangqing: '',
				jilushijian: '',
				userid: ''
			},
			ro:{
				gonghao: false,
				xingming: false,
				bumen: false,
				touxiang: false,
				xiangmumingcheng: false,
				xiangmuxiangqing: false,
				jilushijian: false,
				userid: false
			},
			rules: {
				xiangmumingcheng: [
					{ required: true, message: '项目名称不能为空', trigger: 'blur' }
				],
				xiangmuxiangqing: [
					{ required: true, message: '项目详情不能为空', trigger: 'blur' }
				]
			}
		}
	},
	props: [],
	computed: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
		init(id, type) {
			// 加载员工列表（每次打开都需要加载）
			this.getYuangongList()
			
			if(id){
				this.id = id
				this.type = type
			}
			if (this.type == 'info') {
				this.info(id)
			}else if(this.type == 'else'){
				// type=='else' 且有id：修改模式，禁用字段
				// type=='else' 且无id：新增模式，不禁用字段
				if(id){
					// 修改模式：禁用字段
					this.ro.gonghao = true
					this.ro.xingming = true
					this.ro.bumen = true
					this.info(id)
				}else{
					// 新增模式：不禁用字段，允许选择员工
					this.ro.gonghao = false
					this.ro.xingming = false
					this.ro.bumen = false
					this.crossRow = ''
					this.crossTips = ''
					this.crossColumnName = ''
					this.crossColumnValue = ''
					this.sessionTable = this.$storage.get("sessionTable")
					// 重置表单为初始状态
					this.ruleForm = {
						gonghao: '',
						xingming: '',
						bumen: '',
						touxiang: '',
						xiangmumingcheng: '',
						xiangmuxiangqing: '',
						jilushijian: '',
						userid: ''
					}
				}
			}else{
				this.sessionTable = this.$storage.get("sessionTable")
				// 重置表单为初始状态
				this.ruleForm = {
					gonghao: '',
					xingming: '',
					bumen: '',
					touxiang: '',
					xiangmumingcheng: '',
					xiangmuxiangqing: '',
					jilushijian: '',
					userid: ''
				}
				// 新增时自动填充当前登录用户信息
				if(!id) {
					this.getUserInfo()
				}
			}
		},
		// 获取员工列表
		getYuangongList() {
			this.$http({
				url: 'yuangong/list',
				method: 'get',
				params: {
					page: 1,
					limit: 999  // 获取所有员工
				}
			}).then(({ data }) => {
				if (data && data.code === 0) {
					// 深拷贝数据，避免Vue响应式对象警告
					this.yuangongList = JSON.parse(JSON.stringify(data.data.list || []))
					console.log('员工列表加载成功:', this.yuangongList.length, '条')
				} else {
					console.error('获取员工列表失败:', data.msg)
					this.$message.error('获取员工列表失败: ' + data.msg)
				}
			}).catch(error => {
				console.error('获取员工列表失败:', error)
				this.$message.error('获取员工列表失败，请检查网络连接')
			})
		},
		// 工号改变时的处理
		onGonghaoChange(value) {
			if (value) {
				// 根据工号查找对应的员工信息
				const yuangong = this.yuangongList.find(item => item.gonghao === value)
				if (yuangong) {
					// 自动填充姓名、部门等信息
					this.ruleForm.xingming = yuangong.xingming || ''
					this.ruleForm.bumen = yuangong.bumen || ''
					this.ruleForm.touxiang = yuangong.touxiang || ''
					this.ruleForm.userid = yuangong.id || ''
				}
			}
		},
		// 姓名改变时的处理
		onXingmingChange(value) {
			if (value) {
				// 根据姓名查找对应的员工信息
				const yuangong = this.yuangongList.find(item => item.xingming === value)
				if (yuangong) {
					// 自动填充工号、部门等信息
					this.ruleForm.gonghao = yuangong.gonghao || ''
					this.ruleForm.bumen = yuangong.bumen || ''
					this.ruleForm.touxiang = yuangong.touxiang || ''
					this.ruleForm.userid = yuangong.id || ''
				}
			}
		},
		// 获取当前登录用户信息
		getUserInfo() {
			const sessionTable = this.$storage.get("sessionTable")
			// 只有员工角色才自动填充
			if(sessionTable === 'yuangong') {
				this.$http({
					url: `${sessionTable}/session`,
					method: 'get'
				}).then(({ data }) => {
					if (data && data.code === 0) {
						const userInfo = data.data
						// 自动填充工号、姓名、部门
						this.ruleForm.gonghao = userInfo.gonghao || ''
						this.ruleForm.xingming = userInfo.xingming || ''
						this.ruleForm.bumen = userInfo.bumen || ''
						this.ruleForm.touxiang = userInfo.touxiang || ''
						this.ruleForm.userid = userInfo.id || ''
						
						// 提示用户信息已自动填充
						this.$message({
							message: '已自动填充当前用户信息',
							type: 'success',
							duration: 1500
						})
					}
				}).catch(error => {
					console.error('获取用户信息失败:', error)
				})
			}
		},
		info(id) {
			this.$http({
				url: `gongzuojilu/info/${id}`,
				method: 'get'
			}).then(({ data }) => {
				if (data && data.code === 0) {
					// 深拷贝数据，避免Vue响应式对象警告
					this.ruleForm = JSON.parse(JSON.stringify(data.data))
				} else {
					this.$message.error(data.msg)
				}
			})
		},
		onSubmit() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let url = this.ruleForm.id ? 'gongzuojilu/update' : 'gongzuojilu/save'
					this.$http({
						url: url,
						method: 'post',
						data: this.ruleForm
					}).then(({ data }) => {
				if (data && data.code === 0) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.$emit('refreshDataList')
						}
					})
				} else {
					this.$message.error(data.msg)
				}
			})
		}
	})
},
back() {
	this.$emit('refreshDataList')
}
	}
}
</script>

<style lang="scss" scoped>
.add-update-preview {
	.btn3 {
		color: #fff;
	}
	.btn4 {
		border-color: rgba(86,178,198,1);
		background: #fff;
		color: rgba(86,178,198,1);
	}
	.btn5 {
		border-color: rgba(86,178,198,1);
		background: #fff;
		color: rgba(86,178,198,1);
	}
	
	// 下拉选择框样式
	.select ::v-deep .el-select {
		width: 100%;
	}
	
	.select ::v-deep .el-input__inner {
		width: 100%;
	}
}
</style>

